const nonceElement = document.querySelector('script[nonce]')

export default function getNonce() {
  if (nonceElement) {
    return nonceElement.nonce
  }
}